import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { styled } from '@xstyled/styled-components';
import { AudioFieldProps, MediaFile } from '../types';
import { FieldWrapper } from '../sharedComponents';
import NarrationPopup from '~/editor/narration/NarrationPopup';
import MicrophoneIcon from '~/assets/icons/microphone.svg';

const LightButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  border-radius: 10px;
  font-family: Raleway;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #d5c3f5;
  background: #f3ecff;
  color: #9738ff;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background: #e6d6ff;
  }
  @media (max-height: 900px) {
    padding: 9px 18px;
    font-size: 14.5px;
  }
  @media (max-height: 780px) {
    padding: 8px 16px;
    font-size: 14px;
  }
`;

export const AudioField: React.FC<AudioFieldProps> = ({
  audioFile,
  hasExistingAudio,
  onAudioSelect,
  disabled = false
}) => {
  const [showAudioPicker, setShowAudioPicker] = useState(false);

  const handleAudioSelect = (
    selectedAudio: {
      id?: number | string;
      mediaUrl?: string;
      [key: string]: unknown;
    } | null
  ) => {
    onAudioSelect(selectedAudio as MediaFile | null);
    setShowAudioPicker(false);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      setShowAudioPicker(true);
    }
  };

  return (
    <>
      <FieldWrapper>
        {audioFile || hasExistingAudio ? (
          <LightButton
            type="button"
            onClick={handleButtonClick}
            disabled={disabled}
            aria-label="Change Audio"
          >
            Change Audio
          </LightButton>
        ) : (
          <LightButton
            type="button"
            onClick={handleButtonClick}
            disabled={disabled}
            aria-label="Add Audio"
          >
            <MicrophoneIcon />
            Add Audio
          </LightButton>
        )}
      </FieldWrapper>

      {showAudioPicker &&
        ReactDOM.createPortal(
          <NarrationPopup
            onClose={() => setShowAudioPicker(false)}
            skipUpdate={true}
            onSelectCallback={handleAudioSelect}
            id={audioFile?.id?.toString()}
            skipSequenceNarration={true}
            disableUnassign={true}
            currentAudio={
              audioFile as unknown as {
                id?: number | string;
                [key: string]: unknown;
              }
            }
          />,
          document.body
        )}
    </>
  );
};
